<template>
    
    <div v-if="metrics">
        
        <!-- <b-field label="Metrics">
            <b-select @input="chart" v-model="metric_name" expanded size="is-small" placeholder="Select a metric">
                <option
                    v-for="metric in ['f1score', 'count']"
                    :value="metric"
                    :key="metric">
                    {{ metric }}
                </option>
            </b-select>
        </b-field> -->
        <div id="chart" style="margin-left: -1.5em; margin-top: -1em; min-height: 300rem;">
            <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
        </div>
        
        
    </div>
</template>
<script>

   export default {
     props: ["project", 'metric_name'],
     name: "ProjectMetrics",
     data: function() {
        return {
            series: [],
            chartOptions: {},
            scores: [],
            labels: []
        }
    },
    computed: {
        metrics() {
            return this.$store.state.metrics
        },
    },
    methods: {
        
        chart() {
            
            this.scores = this.metrics.map( s => parseInt(s.labeled))
            this.labels = this.metrics.map( s => s.label)

            let height = toString(20*this.labels.length)

            this.series = [{
                data: this.scores
            }]

            this.chartOptions = {
                chart: {
                type: 'bar',
                width: '200%',
                height: height,
                events: {
                    click: function(chartContext, seriesIndex, config) {
                        alert(config, seriesIndex)
                    }
                },
                toolbar: {
                    show: false,
                    tools: {
                        download: false,
                        selection: true,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        grid: false,
                    }
                },
                },
                plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                    barHeight: '90%',
                    dataLabels: {
                    position: 'bottom'
                    },
                }
                },
                dataLabels: {
                enabled: true,
                textAnchor: 'start',
                style: {
                    colors: ['#fff']
                },
                formatter: function (val, opt) {
                    return opt.w.globals.labels[opt.dataPointIndex]+ ` (${val})`
                },
                offsetX: 0
                },
                crosshairs: {
                    fill: {
                    type: 'gradient',
                    gradient: {
                        colorFrom: '#D8E3F0',
                        colorTo: '#BED1E6',
                        stops: [0, 100],
                        opacityFrom: 0.4,
                        opacityTo: 0.5,
                    }
                    }
                },
                xaxis: {
                categories: this.labels,
                labels: {
                    show: false
                }
                },
                labels: Array.apply(null, {length: 39}).map(function(el, index){
                return index + 1;
                }),
                yaxis: {
                labels: {
                    show: false
                }
                },
                
                zoom: {
                    enabled: false,
                },
                grid: {
                    show: false,
                },
                tooltip: {
                theme: 'dark',
                marker: {
                    show: false,
                },
                x: {
                    show: false
                },
                y: {
                    title: {
                    formatter: function () {
                        return `${metric_name}`
                    }
                    }
                }
                }
                
            }
            
            }
    },
     created(){
        this.chart()
     }
   }
</script>